export const NEWSLETTER_SOURCE_PARAM = 'from';
export const NEWSLETTER_SOURCE_VALUE = 'nl';
export const STORAGE_KEY_NEWSLETTER_BYPASS_PATH = 'newsletter-bypass-path';

// Matches /cashback/fiche/{type}/{query} with an optional 2-letter locale prefix.
const MERCHANT_PAGE_REGEX = /^(?:\/[a-z]{2})?\/cashback\/fiche\/[^/]+\/[^/]+\/?$/;

// Matches the program home page ("/"), with an optional 2-letter locale prefix.
const HOME_PAGE_REGEX = /^(?:\/[a-z]{2})?\/?$/;

export const isMerchantPagePath = pathname =>
    typeof pathname === 'string' && MERCHANT_PAGE_REGEX.test(pathname);

export const isHomePagePath = pathname =>
    typeof pathname === 'string' && pathname !== '' && HOME_PAGE_REGEX.test(pathname);

const hasNewsletterSourceParam = search => {
    if (typeof search !== 'string' || search === '') return false;
    try {
        return (
            new URLSearchParams(search).get(NEWSLETTER_SOURCE_PARAM) === NEWSLETTER_SOURCE_VALUE
        );
    } catch (e) {
        return false;
    }
};

const readBypassPath = () => {
    try {
        return sessionStorage.getItem(STORAGE_KEY_NEWSLETTER_BYPASS_PATH);
    } catch (e) {
        return null;
    }
};

const writeBypassPath = pathname => {
    try {
        sessionStorage.setItem(STORAGE_KEY_NEWSLETTER_BYPASS_PATH, pathname);
    } catch (e) {
        // sessionStorage may be unavailable (private mode, quota, etc.)
    }
};

/**
 * Newsletter redirectors (link.programmecashback.labanquepostale.fr) strip the
 * HTTP Referer, so the redirected URL must carry ?from=nl. When a visitor
 * lands on a merchant page or on the program home page with that marker, store
 * the exact pathname so the auth wall is skipped for that single URL during
 * the tab session.
 */
export const initNewsletterBypass = (pathname, search) => {
    if (!isMerchantPagePath(pathname) && !isHomePagePath(pathname)) return;
    if (!hasNewsletterSourceParam(search)) return;
    writeBypassPath(pathname);
};

export const isNewsletterBypassActive = pathname => {
    if (typeof pathname !== 'string' || pathname === '') return false;
    return readBypassPath() === pathname;
};



// WEBPACK FOOTER //
// ./src/utils/newsletterReferer.js